module.exports = __webpack_public_path__ + "img/re_women.defec16b.png";